import { ReaderTypes } from '../../enums/file-reader/reader-types';
import { IFileReader } from '../../interfaces/file-io/ifile-reader';
import { FileReaderConfigTypes } from '../../types/file-reader-config-types';
import { CsvReaderProps } from '../file-reader/csv-reader-props';
import { SftpConnectorBase } from './sftp-connector-base';

/**
 * Configuration for an SFTPReader task. Extends SftpConnectorBase with file
 * format settings. readerConfig shape depends on readerType (CSV/XML/JSON).
 */
export class SftpReaderConfig extends SftpConnectorBase implements IFileReader {
	/**
	 * File format to parse. CSV=0, XML=1, JSON=2.
	 * @default ReaderTypes.CSV
	 */
	readerType = ReaderTypes.CSV;

	/**
	 * Format-specific reader configuration. Use CsvReaderProps for CSV,
	 * XmlReaderProps for XML, JsonReaderProps for JSON. All types inherit
	 * FileReaderBase (fileReadLimit, onSuccessAction, onFailureAction, etc.).
	 */
	readerConfig: FileReaderConfigTypes = new CsvReaderProps();

	constructor(init?: Partial<SftpReaderConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
